import ROUTE from './routeEnum'

const router = [
    {
        path: '/',
        name: ROUTE.HOME,
        component: () => import('../layout/Home.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/auth',
        name: ROUTE.AUTH,
        component: () => import('../modules/auth/Auth.vue')
    },
    {
        path: '/profile',
        name: ROUTE.PROFILE,
        component: () => import('../modules/profile/Profile.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/users',
        name: ROUTE.USERS,
        component: () => import('../modules/users/Users.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/facturations',
        name: ROUTE.FACTURATIONS,
        component: () => import('../modules/facturation/Facturations.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/suiviCA',
        name: ROUTE.SUIVICA,
        component: () => import('../modules/suivi-ca/SuiviCA.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/suiviConso',
        name: ROUTE.SUIVICONSO,
        component: () => import('../modules/suivi-conso/SuiviConso.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/registration',
        name: ROUTE.REGISTRATION,
        component: () => import('../modules/registration/Registration.vue')
    },
    {
        path: '/formulaires',
        name: ROUTE.FORMULAIRE,
        component: () => import('../modules/formulaires/Formulaire.vue')
    },
    {
        path: '/etat-stock',
        name: ROUTE.ETATSTOCK,
        component: () => import('../modules/etat-stock/EtatStock.vue')
    },
    {
        path: '/pmn-administration',
        name: ROUTE.PMNADMINISTRATION,
        component: () => import('../modules/pmn/pmn-administration/PMNAdministration.vue')
    },
    {
        path: '/pmn-client',
        name: ROUTE.PMNCLIENT,
        component: () => import('../modules/pmn/pmn-client/PMN-Client.vue')
    },
    {
        path: '/pmn-biobank',
        name: ROUTE.PMNBIOBANK,
        component: () => import('../modules/pmn/pmn-biobank/PMN-Biobank.vue')
    },
    {
        path: '/ged',
        name: ROUTE.GED,
        component: () => import('../modules/ged/GED.vue')
    },
    {
        path: '/pdf-viewer/:pdfUrl',
        name: ROUTE.PDF,
        component: () => import('../modules/pdf-viewer/PDFViewer.vue')
    },
    {
        path: '/evenements',
        name: ROUTE.EVENEMENTS,
        component: () => import('../modules/evenements/Evenement.vue')
    },
    {
        path: '/contact',
        name: ROUTE.FORMULAIRE_REPONSES,
        component: () => import('../modules/formulaires/FormulaireReponse.vue')
    },
    {
        path: '/formulaire-reponses',
        name: ROUTE.FORMULAIRE_REPONSES_ADMIN,
        component: () => import('../modules/formulaires/FormulaireReponseAdministration.vue')
    },
    {
        path: '/inventaires',
        name: ROUTE.INVENTAIRES,
        component: () => import('../modules/inventaires/Inventaire.vue')
    },
    {
        path: '/commandes',
        name: ROUTE.COMMANDES,
        component: () => import('../modules/commandes/Commande.vue')
    },
    {
        path: '/fiche-implantation',
        name: ROUTE.FICHE_IMPLANTATION,
        component: () => import('../modules/fiche-implantation/FicheImplantation.vue')
    },
    {
        path: '/fiche-implantation-admin',
        name: ROUTE.FICHE_IMPLANTATION_ADMIN,
        component: () => import('../modules/fiche-implantation/FicheImplantationAdmin.vue')
    },
    {
        path: '/administration-produits',
        name: ROUTE.PRODUIT_ADMIN,
        component: () => import('../modules/produit-administration/ProduitAdministration.vue')
    },
    {
        path: '/app-url-inventaire',
        anme: ROUTE.URLAPPINVENTAIRE,
        component: () => import('../modules/app-administration/UrlAppInventaireAdmin.vue')
    },
    {
        path: '/import-rotation-produits',
        name: ROUTE.IMPORT_ROTATION_PRODUITS,
        component: () => import('../modules/etat-stock/ImportRotation.vue')
    },
    {
        path: '/suivi-recueil',
        name: ROUTE.SUIVI_RECUEIL,
        component: () => import('../modules/suivi-recueil/SuiviRecueil.vue')
    },
    {
        path: '/kits',
        name: ROUTE.KITS,
        component: () => import('../modules/kitsPrets/Kits.vue'),
        props: {kits : true, prets : false}
    },
    {
        path: '/prets',
        name: ROUTE.PRETS,
        component: () => import('../modules/kitsPrets/Kits.vue'),
        props: { kits: false, prets : true }
    },
    {
        path: '/ResetPassword',
        anme: ROUTE.RESETPASSWORD,
        component: () => import('../modules/reset-password/ResetPassword.vue')
    },    
    {
        path: '/actualites',
        name: ROUTE.ACTUALITES,
        component: () => import('../modules/actualites/Actualites.vue')
    },
]

export default router
